<template>
  <AccordionPanel :value="index">
    <AccordionHeader>
      <div class="flex flex-row gap-3 mx-5 w-full">
        <div class="flex flex-col me-8">
          <p class="text-xl text-center">Unit</p>
          <p class="text-3xl font-bold text-center">{{ unit.name }}</p>
        </div>

        <div class="flex flex-row w-full justify-evenly">
          <EntityLookupNoForm :lookup-items="entities" name="entityLookup" label="Buyer" size="w-96"></EntityLookupNoForm>
          <StackedLabelInputNumberNoForm
            v-model="unit.deposit"
            name="depositAmount"
            label="Deposit"
            mode="currency"
            size="w-96"
            @click.stop
          ></StackedLabelInputNumberNoForm>
          <div class="w-96 my-auto">
            <LabelField label="Total Paydown" :display="formatCurrency(unit.totalPaydown)"></LabelField>
            <LabelField label="Outstanding Principal" :display="formatCurrency(outstandingPrincipal)"></LabelField>
          </div>
        </div>

        <ToggleButton v-model="unit.sold" onLabel="Sold" offLabel="Not Sold" class="h-10 w-28 my-auto ml-auto" @click.stop></ToggleButton>
      </div>
    </AccordionHeader>
    <AccordionContent>
      <div class="flex flex-row">
        <div class="w-1/2">
          <p class="font-bold text-xl underline">Previous Paydowns</p>
          <div v-for="(paydown, index) in unit.paydowns" class="flex flex-col">
            <div class="flex flex-row gap-3">
              <div class="flex flex-row">
                <Button
                  class="pi pi-times rounded-full h-6! w-6! p-0 ps-1 me-2 border-none"
                  severity="danger"
                  outlined
                  @click="removePaydown(index)"
                ></Button>
                <i class="text-lg pi pi-calendar"></i>
                <p class="ml-1 my-auto">
                  {{ paydown.date != null ? format(paydown.date, "MM/dd/yyyy") : "" }}
                </p>
              </div>
              <p class="my-auto">{{ formatCurrency(paydown.amount) }}</p>
              <p class="w-24 my-auto">Check # {{ paydown.checkNumber }}</p>
            </div>
          </div>
        </div>

        <div class="flex flex-row gap-3 ml-auto my-auto">
          <StackedLabelDatePickerNoForm v-model="paydownDate" name="paydownDate" label="Date" size="w-44"></StackedLabelDatePickerNoForm>
          <StackedLabelInputNumberNoForm
            v-model="paydownAmount"
            name="paydownAmount"
            label="Amount"
            mode="currency"
            size="w-50"
          ></StackedLabelInputNumberNoForm>
          <StackedLabelInputNoForm v-model="checkNumber" name="checkNumber" label="Check Number" size="w-36"></StackedLabelInputNoForm>
          <Button class="h-8 w-40 mt-auto mb-1" severity="success" @click="addPaydown">Add Paydown</Button>
        </div>
      </div>
    </AccordionContent>
  </AccordionPanel>
</template>

<script setup lang="ts">
import type { Entity } from "@/types/Entity";
import EntityLookupNoForm from "../non-form-inputs/EntityLookupNoForm.vue";
import ToggleButton from "primevue/togglebutton";
import { formatCurrency } from "@/services/Utility";
import { format } from "date-fns";

const unit = defineModel<any>("unit", { required: true });

interface Props {
  index: number;
  entities: Entity[];
  principal: number;
}
const props = defineProps<Props>();

// const totalPaydown = computed<number>(() => paydowns.value.reduce((accumulator, paydown) => accumulator + paydown.amount, 0));
const outstandingPrincipal = computed<number>(() => props.principal - unit.value.totalPaydown);

// const paydowns = ref<Array<any>>([]);
const paydownDate = ref(new Date());
const paydownAmount = ref(0);
const checkNumber = ref("");

const addPaydown = (): void => {
  unit.value.paydowns.push({
    date: paydownDate.value,
    amount: paydownAmount.value,
    checkNumber: checkNumber.value,
  });

  unit.value.totalPaydown = unit.value.paydowns.reduce((accumulator: any, paydown: any) => accumulator + paydown.amount, 0);

  paydownAmount.value = 0;
  checkNumber.value = "";
};

const removePaydown = (index: number): void => {
  unit.value.paydowns.splice(index, 1);
  unit.value.totalPaydown = unit.value.paydowns.reduce((accumulator: any, paydown: any) => accumulator + paydown.amount, 0);
};
</script>
